/**
 * Application configuration constants
 * Values are loaded from environment variables (import.meta.env)
 */

// DigitalOcean Spaces CDN URL (supports both /app and /app-dev paths)
export const SPACES_URL = import.meta.env.VITE_SPACES_URL || '';

// Environment (development, staging, production)
export const ENV = import.meta.env.VITE_ENV || 'development';

// Google Analytics ID
export const GA_ID = import.meta.env.VITE_GA_ID || '';

// API configuration
export const API_CONFIG = {
  // Retry configuration for failed requests
  retries: 3,
  retryDelays: [1000, 2000, 4000], // Exponential backoff in milliseconds

  // Cache configuration
  cacheMaxAge: 300, // 5 minutes

  // Timeout configuration
  requestTimeout: 10000, // 10 seconds
};

// Check if we're in development mode
export const isDevelopment = ENV === 'development';
export const isStaging = ENV === 'staging';
export const isProduction = ENV === 'production';

// Use mock data in development if no CDN URL is provided
export const useMockData = isDevelopment && !SPACES_URL;

// Language code(s) for which signup should be skipped
// Can be single language (e.g., 'en') or comma-separated (e.g., 'en,fr,pl')
export const SKIP_SIGNUP_FOR_LANGUAGE = import.meta.env.VITE_SKIP_SIGNUP_FOR_LANGUAGE || '';

// Language code(s) for which "Share your voice" feedback section should be hidden on completion page
// Can be single language (e.g., 'en') or comma-separated (e.g., 'en,fr')
export const SKIP_SHARE_VOICE_FOR_LANGUAGE = import.meta.env.VITE_SKIP_SHARE_VOICE_FOR_LANGUAGE || '';
